(function () {
  function initSlider(root) {
    if (!root || root.dataset.ttgSliderReady === 'true') return;
    root.dataset.ttgSliderReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ttg-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ttg-panel]'));

    function updateArrows(panel) {
      if (!panel) return;
      var track = panel.querySelector('[data-ttg-track]');
      var prev = panel.querySelector('[data-ttg-scroll="-1"]');
      var next = panel.querySelector('[data-ttg-scroll="1"]');
      if (!track || !prev || !next) return;

      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    function activateTab(tab, moveFocus) {
      var targetId = tab.getAttribute('aria-controls');

      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var active = panel.id === targetId;
        panel.hidden = !active;
        if (active) {
          var track = panel.querySelector('[data-ttg-track]');
          if (track) track.scrollLeft = 0;
          window.requestAnimationFrame(function () { updateArrows(panel); });
        }
      });

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + tabs.length) % tabs.length;
        activateTab(tabs[nextIndex], true);
      });
    });

    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-ttg-track]');
      if (!track) return;

      Array.prototype.slice.call(panel.querySelectorAll('[data-ttg-scroll]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = parseInt(button.getAttribute('data-ttg-scroll'), 10) || 1;
          track.scrollBy({ left: track.clientWidth * 0.9 * direction, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', function () {
        updateArrows(panel);
      }, { passive: true });
    });

    window.addEventListener('resize', function () {
      panels.forEach(updateArrows);
    });

    panels.forEach(updateArrows);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.ttg-category-bestsellers')).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
